import Service from './service.js';

export class Education extends Service {
    constructor() {
        super('#form-service-education', 'education');
        this.initService();
    };

    initService() {
        document.body.addEventListener('show.bs.modal', event => {
            let url = event.target.dataset.href;
            let submit = event.target.querySelector('.submitButton');
            if(submit) {
                submit.addEventListener('click', event => {
                    event.preventDefault();
                    this.removeSubaccount(url);
                });
            }
        });
    };
    
    submit(event) {
        OVS.app.helper.toggleButton(true);
    };
    
    removeSubaccount(url) {
        let request = new Request('DELETE', url);
        request.call(function(data) {
            if(data.status == 'ok') {
                OVS.app.helper.toggleButton(true);
                window.location.replace(this.form.getAttribute('action'));
            }
        }.bind(this));
    };
};
